export default function IntroBody() {
  return (
    <div className="Intro-body">
      <h1>انا</h1>
    </div>
  );
}
